import { getActiveLanguage } from './localePreference';

const MESSAGES = {
  en: {
    applicationNetwork: 'Unable to reach the application backend.',
    applicationInvalidResponse: 'Application backend returned {status}.',
    applicationRequest: 'Application request failed.',
    careerCoachNetwork: 'Unable to reach the career coach backend.',
    careerCoachRequest: 'Career coach request failed.',
    askRequest: 'Ask Me Anything request failed.',
    askStreamingUnsupported: 'Ask Me Anything streaming is not available in this browser.',
    companyRadarNetwork: 'Unable to reach the Company Radar backend.',
    companyRadarRequest: 'Company Radar request failed.',
    goalsNetwork: 'Unable to reach the goals backend.',
    goalsRequest: 'Goals request failed.',
    learningTimeout: 'The learning assessment request timed out.',
    learningNetwork: 'Unable to reach the learning pathways backend.',
    learningRequest: 'Learning pathways request failed.',
    mockTimeout: 'The mock interview backend timed out.',
    mockNetwork: 'Unable to reach the mock interview backend.',
    mockRequest: 'Mock interview request failed.',
    mockPreparingTimeout: 'The mock interview backend timed out while preparing the voice session.',
    mockReportTimeout: 'Mock interview report generation timed out. Your transcript should still be saved; retry report generation from the report screen.',
    mockRetryTimeout: 'Mock interview report retry timed out. Please retry again from the report screen.',
    onboardingNetwork: 'Unable to reach the onboarding backend.',
    onboardingRequest: 'Onboarding agent request failed.',
    scoutNetwork: 'Unable to reach the Scout backend.',
    scoutRequest: 'Scout request failed.',
    emailNetwork: 'Unable to reach the email integration backend.',
    emailRequest: 'Email integration request failed.',
  },
  ar: {
    applicationNetwork: 'تعذّر الاتصال بخدمة طلبات التوظيف.',
    applicationInvalidResponse: 'أعادت خدمة طلبات التوظيف استجابة غير صالحة ({status}).',
    applicationRequest: 'تعذّر تنفيذ طلب التوظيف.',
    careerCoachNetwork: 'تعذّر الاتصال بخدمة المدرب المهني.',
    careerCoachRequest: 'تعذّر تنفيذ طلب المدرب المهني.',
    askRequest: 'تعذّر تنفيذ طلب «اسألني عن أي شيء».',
    askStreamingUnsupported: 'لا يدعم هذا المتصفح عرض إجابة «اسألني عن أي شيء» بشكل مباشر.',
    companyRadarNetwork: 'تعذّر الاتصال بخدمة رادار الشركات.',
    companyRadarRequest: 'تعذّر تنفيذ طلب رادار الشركات.',
    goalsNetwork: 'تعذّر الاتصال بخدمة الأهداف.',
    goalsRequest: 'تعذّر تنفيذ طلب الأهداف.',
    learningTimeout: 'انتهت مهلة طلب تقييم مسار التعلّم.',
    learningNetwork: 'تعذّر الاتصال بخدمة مسارات التعلّم.',
    learningRequest: 'تعذّر تنفيذ طلب مسارات التعلّم.',
    mockTimeout: 'انتهت مهلة الاتصال بخدمة المقابلة التدريبية.',
    mockNetwork: 'تعذّر الاتصال بخدمة المقابلة التدريبية.',
    mockRequest: 'تعذّر تنفيذ طلب المقابلة التدريبية.',
    mockPreparingTimeout: 'انتهت مهلة تجهيز جلسة المقابلة الصوتية.',
    mockReportTimeout: 'انتهت مهلة إنشاء تقرير المقابلة. يجب أن يبقى النص محفوظاً؛ أعد إنشاء التقرير من شاشة التقارير.',
    mockRetryTimeout: 'انتهت مهلة إعادة إنشاء تقرير المقابلة. حاول مجدداً من شاشة التقارير.',
    onboardingNetwork: 'تعذّر الاتصال بخدمة الإعداد الأولي.',
    onboardingRequest: 'تعذّر تنفيذ طلب الإعداد الأولي.',
    scoutNetwork: 'تعذّر الاتصال بخدمة باحث الوظائف.',
    scoutRequest: 'تعذّر تنفيذ طلب باحث الوظائف.',
    emailNetwork: 'تعذّر الاتصال بخدمة ربط البريد الإلكتروني.',
    emailRequest: 'تعذّر تنفيذ طلب ربط البريد الإلكتروني.',
  },
};

export function apiErrorMessage(key, values = {}) {
  const language = getActiveLanguage();
  const template = MESSAGES[language]?.[key] || MESSAGES.en[key] || key;
  return Object.entries(values).reduce(
    (message, [name, value]) => message.replaceAll(`{${name}}`, String(value)),
    template,
  );
}
